import { forwardRef } from 'react';

import { Typography } from '..';

import type { ISelectProps } from './input.interface';

import './input.scss';

export const Select = forwardRef<HTMLSelectElement, ISelectProps>(
  (
    {
      label,
      name,
      error,
      disabled = false,
      color = 'default',
      autocomplete = 'off',
      size = 'medium',
      selected,
      value,
      ...props
    }: ISelectProps,
    forwardRef
  ) => {
    let inputClass = '';
    if (disabled) {
      inputClass = 'disabled co-bg-gray-xlight co-border-disabled-main';
    } else if (error) {
      inputClass = 'co-border-error-main co-bg-common-white';
    } else {
      if (color === 'success') {
        inputClass = 'co-border-success-main';
      } else {
        inputClass = 'co-border-common-default';
      }
    }

    function createSize(): string {
      if (size === 'large') {
        return 'co-h-56px';
      }
      if (size === 'medium') {
        return 'co-h-48px';
      }
      return 'co-h-40px';
    }

    return (
      <div className="co-flex co-select-item co-flex-wrap co-gap-8px co-mb-8">
        <label
          className={`
                        co-flex-1
                        co-relative
                        co-m-0
                        co-pl-0
                        co-label-${size}
                    `}
          htmlFor={name}
        >
          <select
            autoComplete={autocomplete}
            disabled={disabled}
            className={`
                        ${inputClass}
                        co-input-text-${size}
                        co-px-16px
                        co-w-full
                        ${createSize()}
                        co-border-1
                        co-rounded-md
                        co-font-normal
                        `}
            value={value}
            name={name}
            id={name}
            ref={forwardRef}
            {...props}
          >
            <option value="" hidden></option>
            {props.options.map((option, index) => {
              return (
                <option key={index} value={option.value}>
                  {option.name}
                </option>
              );
            })}
          </select>
          <span
            className={`
                        co-text-common-default
                        co-px-8px
                        co-rounded-md
                        ${disabled ? 'co-bg-transparent' : 'co-bg-common-white'}
                        co-absolute
                        co-left-8px
                        ${selected && `co-translate-span-${size}`}
                    `}
          >
            <Typography size="body1" noWrap>
              {label}
            </Typography>
          </span>
        </label>
        {error && (
          <div className="co-w-full">
            {typeof error === 'string' ? (
              <Typography color="error">{error}</Typography>
            ) : (
              error
            )}
          </div>
        )}
      </div>
    );
  }
);
